import "./styles/Event.scss";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
//import CssBaseline from "@material-ui/core/CssBaseline";
import React, { useEffect, useMemo, useState } from "react";
import { GetUrl, FetchConfig } from "../helpers/ConfigApi";
import { useInterval } from "../hooks/useInterval";
import { useParams } from "react-router-dom";
import Banner from "components/layout/Header";
import EventContactForm from "components/forms/EventContactForm";
import EventQuestionForm from "components/forms/EventQuestionForm";
import { GetDefaultVideo } from "../helpers/ConfigApi";
import HelpOutline from "@material-ui/icons/HelpOutline";
import VideoPlayer from "../components/video/VideoPlayerJS";
import { v4 as uuid } from "uuid";
import Content from "components/content/Content";
import Loading from "../containers/Loading";
import Footer from "components/layout/Footer";

const Event = (props) => {
  const {id} = useParams();
  //const {playerSection, speakersSection, resourcesSection, contactSection} = config.eventPage;

  
  //console.log('defaultVideo=========', defaultVideo)

  //const [playerSrc, setPlayerSrc] = useState(defaultVideo);
  //const [childSrc, setChildSrc] = useState(playerSrc);
  const [url, setUrl] = useState(GetUrl(id));
  const [isInitialising, setIsInitialising] = useState(true);
  const [config, setConfig] = useState();
  const [message, setMessage] = useState({
    type: "info",
    description: "Loading ... ",
  });
  //const defaultVideo = useMemo(() => GetDefaultVideo(config), [config]);
  // useEffect(() => {
  //   setPlayerSrc(childSrc);
  // }, [childSrc]);

  
  useEffect(() => {
    if (url) {
      FetchConfig(url)
        .then((newConfig) => {
          if (newConfig) {
            setConfig(newConfig);
            setIsInitialising(false);
          }
        })
        .catch((e) => {
          console.log(e);
          setMessage({ type: "error", description: e.message });
        });
    }
  }, [url]);

  useInterval(() => {
    setUrl(GetUrl(id));
  }, 60000);

  console.log('config=======', config);
 
  // useEffect(() => {
  //   // if the player is currently playing the default video
  //   // reload it, if the defaultVideo has been changed,
  //   // or a video src has been updated in the config file
  //   if (playerSrc && config && config.videos) {
  //     for (let i = 0; i < config.videos.length; i++) {
  //       if (playerSrc.id === config.videos[i].id) {
  //         setChildSrc(defaultVideo);
  //       }
  //     }
  //   }
  // }, [playerSrc, config, defaultVideo]);

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#000000de",
        contrastText: "#fff",
      },
      secondary: {
        main: "#315370",
        contrastText: "#fff",
      },
    },
    typography: {
      fontFamily: ["Montserrat", "sans-serif"].join(
        ","
      ),
    },
  });
  console.log("event config : ", config);
  return (
    <MuiThemeProvider theme={theme}>
      
      {isInitialising && (
        <Loading message={message} />
      )}
      {!isInitialising && (
        <>
       <Banner config={config}/>
       <Content config={config} />
       <Footer config={config}/>
       </>
      )}
      
    </MuiThemeProvider>
  );
};

export default Event;
